import { render, staticRenderFns } from "./SocialResponsibility.vue?vue&type=template&id=41a683ea&scoped=true&"
import script from "./SocialResponsibility.vue?vue&type=script&lang=js&"
export * from "./SocialResponsibility.vue?vue&type=script&lang=js&"
import style0 from "./SocialResponsibility.vue?vue&type=style&index=0&id=41a683ea&prod&scoped=true&lang=css&"
import style1 from "./SocialResponsibility.vue?vue&type=style&index=1&id=41a683ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a683ea",
  null
  
)

export default component.exports